import { request } from '../../helpers/apiHelper'
import { displayNotification } from '../../actions/notificationsActions'
import { mappingQuery, mappingsQuery, updateMappingMutation } from './queries'

export enum MappingActionType {
  FETCH_STIPULATION_MAPPING_FAILURE = 'FETCH_STIPULATIONMAPPING_FAILURE',
  FETCH_STIPULATION_MAPPING_SUCCESS = 'FETCH_STIPULATIONMAPPING_SUCCESS',
  FETCH_STIPULATION_MAPPINGS_FAILURE = 'FETCH_STIPULATIONMAPPINGS_FAILURE',
  FETCH_STIPULATION_MAPPINGS_SUCCESS = 'FETCH_STIPULATIONMAPPINGS_SUCCESS',
  UPDATE_STIPULATION_MAPPING_SUCCESS = 'UPDATE_STIPULATIONMAPPING_SUCCESS',
  UPDATE_STIPULATION_MAPPING_FAILURE = 'UPDATE_STIPULATIONMAPPING_FAILURE',
}

export const fetchMappings = (varObject) => (dispatch) => {
  return request(mappingsQuery.default, varObject)
    .then((response) => {
      dispatch({
        type: MappingActionType.FETCH_STIPULATION_MAPPINGS_SUCCESS,
        entities: response.data.data.stipulationMappings.items,
        meta: response.data.data.stipulationMappings.meta,
      })
    })
    .catch(() => {
      dispatch({
        type: MappingActionType.FETCH_STIPULATION_MAPPINGS_FAILURE,
      })
      dispatch(
        displayNotification(
          'Failed to fetch Stipulation Mappings',
          'error',
          10000
        )
      )
    })
}

export const fetchMapping = (id) => (dispatch) => {
  return request(mappingQuery.default, { id })
    .then((response) => {
      const mapping = response.data.data.stipulationMapping
      dispatch({
        type: MappingActionType.FETCH_STIPULATION_MAPPING_SUCCESS,
        entity: mapping,
      })
      return mapping
    })
    .catch(() => {
      dispatch({
        type: MappingActionType.FETCH_STIPULATION_MAPPING_FAILURE,
      })
      dispatch(
        displayNotification(
          'Failed to fetch Stipulation Mapping',
          'error',
          10000
        )
      )
    })
}

export const updateMapping = (mapping) => (dispatch) => {
  return request(updateMappingMutation.default, { mapping })
    .then(() => {
      dispatch({ type: MappingActionType.UPDATE_STIPULATION_MAPPING_SUCCESS })
      dispatch(displayNotification('Stipulation Mapping updated'))
    })
    .catch(() => {
      dispatch({ type: MappingActionType.UPDATE_STIPULATION_MAPPING_FAILURE })
      dispatch(
        displayNotification('Stipulation Mapping update failed', 'error', 10000)
      )
    })
}
